import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import DialogContent from '@mui/material/DialogContent';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import PersonSearchRoundedIcon from '@mui/icons-material/PersonSearchRounded';
import CreateIcon from '@mui/icons-material/Create';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import ROUTES from 'shared/routes';
import TrackedButton from 'components/inputs/TrackedButton';
import TrackedCloseButton from 'components/inputs/TrackedCloseButton';
import PrivacyLink from '../inputs/PrivacyLink';

const points = [
    {
        index: 1,
        icon: <PersonSearchRoundedIcon fontSize='small' />,
        header: 'Book Your Favorite DJs',
        text: 'Select from a number of available DJs'
    },
    {
        index: 2,
        icon: <CreateIcon fontSize='small' />,
        header: 'Request For Extra Equipments',
        text: 'Request for extra equipments for your events'
    },
    {
        index: 3,
        icon: <QuestionAnswerIcon fontSize='small' />,
        header: 'In App Chat With Your DJ',
        text: 'Chat with the DJ within the app until service is delivered'
    }
];

const DjBookingNotification = () => {
    return (
        <Container maxWidth='sm' className='notification'>
            <Box
                pl={3}
                pt={3}
                style={{
                    background:
                        'linear-gradient(rgba(0, 0, 0, 0.358) 85%, rgb(0, 0, 0)), url(/static/images/book-dj-banner.png) center center no-repeat'
                }}
            >
                <TrackedCloseButton name={'dj-booking'} />
                <Box pl={5} pt={6} id='notification-title'>
                    <Typography variant='h6'>Introducing</Typography>
                    <Typography fontWeight={'bold'} variant='h4'>
                        DJ Booking
                    </Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    backgroundColor: '#000000'
                }}
            >
                <DialogContent>
                    <List>
                        {points.map(point => (
                            <ListItem key={point.index}>
                                <ListItemAvatar>
                                    <Avatar>{point.icon}</Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    sx={{
                                        textTransform: 'none'
                                    }}
                                    primaryTypographyProps={{
                                        fontSize: 14,
                                        fontWeight: 'bold',
                                        textTransform: 'none'
                                    }}
                                    secondaryTypographyProps={{
                                        fontSize: 10
                                    }}
                                    primary={point.header}
                                    secondary={point.text}
                                />
                            </ListItem>
                        ))}
                    </List>
                </DialogContent>
                <div className='notification-footer'>
                    <div>
                        <TrackedButton
                            event={{
                                event: 'notification:dialog:activity',
                                data: {
                                    name: 'dj-booking',
                                    type: 'click'
                                }
                            }}
                            isClose
                            to={ROUTES.DJS}
                        >
                            Continue
                        </TrackedButton>
                    </div>
                    <PrivacyLink />
                </div>
            </Box>
        </Container>
    );
};

export default DjBookingNotification;
